import axios from "axios";
import { Formik } from "formik";
import { SubTitle } from "../../styled-components/utils/containerStyles";
import {
  ContactForm,
  FormControl,
  FormError,
  Input,
  Select,
  SubmitButton,
  TextArea,
} from "./contactStyles";
import contactSchema, {
  errorNotify,
  notify,
  initialValues,
} from "./contactSchema";
import { ToastContainer } from "react-toastify";
import { useState } from "react";
import { LoadingDiv } from "../../styled-components/utils/LoadingDiv";

const ContactFormMain = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={contactSchema}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          const { data } = await axios.post("/api/contact", {
            ...values,
          });
          if (data.success) {
            notify();
            setIsSubmitted(true);
            resetForm();
          } else {
            throw new Error("Failed");
          }
        } catch (error) {
          errorNotify();
        }
        setSubmitting(false);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <ContactForm
          onSubmit={handleSubmit}
          style={{ marginBottom: "30px", height: "100%" }}
        >
          <ToastContainer />
          <SubTitle style={{ marginBottom: "30px" }}>
            Send Us A Message
          </SubTitle>
          <FormControl>
            <Input
              placeholder="Your Name"
              type="text"
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.name}
            />
            {errors.name && touched.name ? (
              <FormError>{errors.name}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="City"
              type="text"
              name="city"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.city}
            />
            {errors.city && touched.city ? (
              <FormError>{errors.city}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="Your Email"
              type="email"
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
            />
            {errors.email && touched.email ? (
              <FormError>{errors.email}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Input
              placeholder="Your Number"
              type="number"
              name="phNumber"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.phNumber}
            />

            {errors.phNumber && touched.phNumber ? (
              <FormError>{errors.phNumber}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <Select
              placeholder="Type of Consultation"
              name="category"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.category}
              style={{ padding: "10px" }}
            >
              <option value="">Mode of Consultation</option>
              <option value="Offline Consultation">Offline Consultation</option>
              <option value="Online Consultation">Online Consultation</option>
            </Select>
            {errors.category && touched.category ? (
              <FormError>{errors.category}</FormError>
            ) : null}
          </FormControl>
          <FormControl>
            <TextArea
              rows="5"
              placeholder="Matter Summary"
              type="text"
              name="matterSummary"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.matterSummary}
            />
            {errors.matterSummary && touched.matterSummary ? (
              <FormError>{errors.matterSummary}</FormError>
            ) : null}
          </FormControl>
          <SubmitButton type="submit" disabled={isSubmitting || isSubmitted}>
            {isSubmitted ? (
              "Thanks, We will be in touch soon"
            ) : isSubmitting ? (
              <LoadingDiv />
            ) : (
              "Request an Appointment"
            )}
          </SubmitButton>
        </ContactForm>
      )}
    </Formik>
  );
};

export default ContactFormMain;
